export default __webpack_public_path__ + "static/media/coach3.ea81831c.jpg";